import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
} from 'react';
import IconButton from '@mui/material/IconButton';
import clsx from 'clsx';
import ToolTip from 'core/components/Tooltip';
import {
  CalendarEvent,
} from 'pages/Dashboard/pages/Appointments/pages/List/types/appointment';
import {
  Dayjs,
} from 'utils/dayjs';
import {
  DeleteConfirmationParams,
} from 'pages/Dashboard/pages/Appointments/pages/List/components/Details/DeleteConfirmation';
import Spinner from 'pages/Dashboard/components/Spinner';
import DeleteIcon from 'core/icons/delete';
import CloseIcon from '@mui/icons-material/Close';

type Props = {
  data?: CalendarEvent;
  eventDate: Dayjs;
  isNoteFinalized?: boolean;
  setDeleteConfirmationParams: Dispatch<SetStateAction<DeleteConfirmationParams | null>>;
  isDeleting: boolean;
  onClose: () => void;
  actions?: ReactNode;
};

export default function Toolbar({
  eventDate,
  data,
  isNoteFinalized,
  setDeleteConfirmationParams,
  isDeleting,
  onClose,
  actions,
}: Props) {
  const { hasPaymentAllocation, isTimeBlock, isTimeAvailability } = data ?? {};

  const handleDeleteEvent = () => {
    setDeleteConfirmationParams({
      data: data!,
      eventDate,
    });
  };

  return (
    <div className={clsx('flex justify-end h-8 gap-1 items-center mr-3 ', {
      'mt-3': !isTimeAvailability && !isTimeBlock,
    })}
    >
      {!isNoteFinalized && (
        <ToolTip
          title={hasPaymentAllocation
            ? 'Appointment cannot be deleted since it has payment(s) posted'
            : 'Delete'}
          placement="bottom"
        >
          <div>
            <IconButton
              size="small"
              aria-label="Delete Appointment"
              className={clsx('nw-delete-appointment-button', {
                '!cursor-not-allowed !pointer-events-auto !opacity-50': hasPaymentAllocation,
              })}
              color="error"
              onClick={handleDeleteEvent}
              disabled={hasPaymentAllocation}
            >
              {isDeleting
                ? <Spinner />
                : <DeleteIcon className="!w-5 !h-5 text-black" />}
            </IconButton>
          </div>
        </ToolTip>
      )}
      {actions}
      <ToolTip title="Close">
        <IconButton
          size="small"
          className="nw-close-appointment-detail-button"
          onClick={onClose}
        >
          <CloseIcon className="!w-5 !h-5" />
        </IconButton>
      </ToolTip>
    </div>
  );
}
